// src/lib/brandStylePresets.js
export const STYLE_PRESET_OPTIONS = [
  { value: 'auto',        label: 'Auto (from brand vibe)' },
  { value: 'minimalist',  label: 'Minimalist / clean' },
  { value: 'editorial',   label: 'Bold / editorial' },
  { value: 'luxury',      label: 'Premium / luxury' },
  { value: 'gradient_3d', label: 'Modern gradient / 3D' },
]
